import { StreamingFeature } from '@anm/api/modules/subscription';
import { UserSubscriptionDetails } from '@anm/api/modules/user';
import { User } from 'user';

export const LOCAL_DEV_AUTH_TOKEN = process.env.STREAMING_LOCAL_AUTH_TOKEN || 'local-dev-token';
export const LOCAL_DEV_USER_ID = 'localDevUser0001';

export const LOCAL_DEV_STREAMING_FEATURES: StreamingFeature = {
  canLiveStream: true,
  canRecord: true,
  canStreamHosted: true,
  maxDestinations: 20,
  canUseSameTypeDestinations: true,
  maxCameras: 10,
  maxShares: 10,
  maxVideos: 10,
  permissionsControl: 'FULL',
  canEditBrand: true,
  canRemoveLogo: true,
  canUseScenes: true,
  streamingResolution: 'HD1080',
  maxDuration: 720,
  maxGuests: 12,
  maxFeeds: 50,
  slidesEnabled: true,
  canPause: true,
  canRecordAudioTracks: true,
  canRecordLocally: true,
  maxRecordDuration: 720,
  webinarsEnabled: true
};

export const isLocalDevAuthToken = (token?: string | null) => token === LOCAL_DEV_AUTH_TOKEN;
export const isLocalDevUserId = (userId?: string | null) => userId === LOCAL_DEV_USER_ID;

export const createLocalDevWaveSubscription = (): UserSubscriptionDetails =>
  ({
    name: 'Staff',
    product: 'WAVE',
    displayName: 'Local Dev',
    billingPeriod: 'LIFETIME',
    hidden: false,
    excludeFromUI: false,
    annualPrice: 0,
    monthlyPrice: 0,
    upgrades: [],
    hasStripeSubscription: false,
    hasStripeUser: false,
    features: {
      Streaming: LOCAL_DEV_STREAMING_FEATURES
    }
  } as unknown as UserSubscriptionDetails);

export const createLocalDevUser = (): User => ({
  meta: {} as User['meta'],
  email: 'local-dev@wave.video',
  userIdAsString: LOCAL_DEV_USER_ID,
  userId: LOCAL_DEV_USER_ID,
  avatar: '',
  created: 0,
  username: 'local-dev',
  anonymous: false,
  embedStats: {} as User['embedStats'],
  displayName: 'Local Dev',
  emailConfirmed: true,
  subscriptionDetails: [createLocalDevWaveSubscription()]
});
